module.exports = __webpack_public_path__ + "media/images/disable_camera_pause-25e67a499946e43dec2f3301745c16bcf04ca986bbb68e5d96e8fbcdb06f8671.svg";